import type { ICasinoGamesConditions } from '@modules/common/casinoConditions/types';

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { hasPartialUpdates } from '@utils/hasPartialUpdates';

interface IInitialState {
  casinoGamesFormState: ICasinoGamesConditions;
  casinoGamesConfig: {
    isSelectorChanged: boolean;
    isCasinoGamesError: boolean;
  };
}

const initialState: IInitialState = {
  casinoGamesConfig: {
    isSelectorChanged: false,
    isCasinoGamesError: false,
  },
  casinoGamesFormState: {
    includedGamesConditions: [],
    excludedGamesConditions: [],
  },
};

const casinoGamesSlice = createSlice({
  initialState,
  name: 'casinoGamesSlice',
  reducers: {
    resetIncludedGameConditions(state: IInitialState) {
      state.casinoGamesFormState.includedGamesConditions =
        initialState.casinoGamesFormState.includedGamesConditions;
    },
    resetExcludedGameConditions(state: IInitialState) {
      state.casinoGamesFormState.excludedGamesConditions =
        initialState.casinoGamesFormState.excludedGamesConditions;
    },
    setExcludedGamesConditions(
      state: IInitialState,
      action: PayloadAction<ICasinoGamesConditions['excludedGamesConditions']>
    ) {
      state.casinoGamesFormState.excludedGamesConditions = action.payload;
    },
    setIncludedGamesConditions(
      state: IInitialState,
      action: PayloadAction<ICasinoGamesConditions['includedGamesConditions']>
    ) {
      state.casinoGamesFormState.includedGamesConditions = action.payload;
    },
    setCasinoGamesConfig(
      state: IInitialState,
      action: PayloadAction<Partial<IInitialState['casinoGamesConfig']>>
    ) {
      if (!hasPartialUpdates(state.casinoGamesConfig, action.payload)) {
        return;
      }

      Object.assign(state.casinoGamesConfig, action.payload);
    },
  },
});

export default casinoGamesSlice.reducer;

export const {
  setCasinoGamesConfig,
  setIncludedGamesConditions,
  setExcludedGamesConditions,
  resetIncludedGameConditions,
  resetExcludedGameConditions,
} = casinoGamesSlice.actions;
